module.exports = __webpack_public_path__ + "img/default_banner2.f3edfd63.svg";